import { Box, Card, styled } from '@mui/material';
import FlexRowAlign from 'components/flexbox/FlexRowAlign';
import { H3, H5 } from 'components/Typography';
import EarningIcon from 'icons/EarningIcon';
import FormatDate from 'utils/formatDate';

const StyledCard = styled(Card)(({ theme }) => ({
    padding: '0 1.5rem',
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
        padding: '1.5rem',
        flexDirection: 'column',
        justifyContent: 'center',
        '& .MuiBox-root': {
            marginRight: 0,
            textAlign: 'center',
        },
    },
}));

const SaaSCard = ({ data, date }) => {
    return (
        <StyledCard>
            <FlexRowAlign
                sx={{
                    width: 60,
                    height: 60,
                    marginRight: 2,
                    borderRadius: '50%',
                    backgroundColor: 'rgba(167, 152, 255, 0.2)',
                }}
            >
                <EarningIcon />
            </FlexRowAlign>
            <Box
                mt={{
                    xs: '1rem',
                    sm: 0,
                }}
            >
                <H5 color="text.primary" mb={0}>
                    Checkin {FormatDate(date)}
                </H5>
                <H3 mt={0}>{data[0]?.count || '0'} Participant</H3>
            </Box>
        </StyledCard>
    );
};

export default SaaSCard;
